import { FC, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { UAlert, UButton, UText } from "../../../components"
import { Box, Link } from "../../../components/mui.components"
import { useAppDispatch, useAppSelector } from "../../../core/app/hooks"
import { setAlert } from "../../../core/app/slices/alert/alertSlice"
import { RootState } from "../../../core/app/store"
import { CENETER_COLUMN_ALIGN } from "../../../theme/theme.util"

const Footer: FC = () => {
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const { alertMsg } = useAppSelector((state: RootState) => state.alert)
  const { t } = useTranslation("common")

  useEffect(() => {
    if (alertMsg) {
      setShowAlert(true)
    }
  }, [alertMsg])

  const closeAlert = () => {
    setShowAlert(false)
    dispatch(setAlert(""))
  }

  return (
    <Box
      component={"div"}
      sx={{
        ...CENETER_COLUMN_ALIGN,
        backgroundColor: "#F1F2F4",
        py: "22px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {alertMsg && showAlert && (
        <UAlert
          alertContent={
            <>
              <UText
                sxProp={{
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "143%",
                }}
              >
                {alertMsg}
              </UText>
            </>
          }
          variant={"filled"}
          severity={"success"}
          alertProps={{ paddingBottom: "10px" }}
          showAlert={showAlert}
          onClickHandler={closeAlert}
        ></UAlert>
      )}
      <UText
        sxProp={{ fontSize: "11px", fontWeight: "300", opacity: "60%" }}
        color={"#000000"}
        component={"p"}
      >
        {t("footer.description")}{" "}
        <Link
          href="tel:+18669008522"
          sx={{ textDecoration: "none", color: "#000000", fontWeight: "500" }}
        >
          {t("footer.phone")}{" "}
        </Link>
        {t("footer.emailTitle")}{" "}
        <Link
          href={"mailto: support@ulabsystems.com"}
          sx={{ textDecoration: "none", color: "#000000", fontWeight: "500" }}
        >
          {t("footer.email")}
        </Link>
      </UText>
      <Box component={"div"} sx={{ pt: "4px" }}>
        <UText
          color={"#000000"}
          component={"div"}
          sxProp={{
            display: "flex",
            alignItems: "center",
            fontSize: "9px",
            fontWeight: "300",
            opacity: "60%",
          }}
        >
          {t("footer.rights")}
          <Box
            component="div"
            sx={{
              borderLeft: "1px solid #000000",
              opacity: "0.28",
              height: "12px",
              mx: 1,
            }}
          ></Box>
          <Link
            href="#"
            sx={{
              textDecoration: "none",
              color: "#000000",
              fontWeight: "500",
            }}
          >
            {t("footer.privacypolicy")}
          </Link>
          <Box
            component="div"
            sx={{
              borderLeft: "1px solid #000000",
              opacity: "0.28",
              height: "12px",
              mx: 1,
            }}
          ></Box>
          <Link
            href="#"
            sx={{
              textDecoration: "none",
              color: "#000000",
              fontWeight: "500",
            }}
          >
            {t("footer.termsandconditions")}
          </Link>
        </UText>
      </Box>
    </Box>
  )
}

export default Footer
